import { BindingCreator } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { invoiceSharedComponentsTranslationKeys } from '../translations';

const COMPANY_NAME_FIELD_NAME = 'companyName';
const COMPANY_NAME_MAX_LENGTH = 255;

export type CompanyNameFormBeanPart = {
   [COMPANY_NAME_FIELD_NAME]: string;
};

type CompanyNameFieldProps = {
   readonly register: BindingCreator<CompanyNameFormBeanPart, typeof COMPANY_NAME_FIELD_NAME>;
};

export const CompanyNameField = (props: CompanyNameFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register(COMPANY_NAME_FIELD_NAME, {
            required: true,
            maxLength: COMPANY_NAME_MAX_LENGTH,
         })}
         testId={COMPANY_NAME_FIELD_NAME}
         label={invoiceSharedComponentsTranslationKeys.companyName}
      />
   );
};
